import { UseMutationOptions } from "@tanstack/react-query";

import { toast } from "components/ui/toast/Toast";
import { graphql } from "lib/generated/app-service-gql";
import {
  RequestManagedResearchMutation,
  RequestManagedResearchMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const requestManagedResearchMutation = graphql(`
  mutation requestManagedResearch($input: RequestManagedResearchInput!) {
    requestManagedResearch(input: $input) {
      id
      status
      summary
    }
  }
`);

export function useAccountBriefingRequest(
  options?: UseMutationOptions<
    RequestManagedResearchMutation,
    unknown,
    RequestManagedResearchMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(requestManagedResearchMutation, {
    ...options,
    onSuccess: async (data, variables, context) => {
      toast.success(
        "Account briefing requested! We will send you your briefing within 5 business days",
      );
      options?.onSuccess?.(data, variables, context);
    },
    onError: (data, variables, context) => {
      toast.error("An error occurred - please try again or get in touch");
      options?.onError?.(data, variables, context);
    },
  });

  return { data: data?.requestManagedResearch, ...rest };
}
